import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Collections } from "../components/site/Collections";
import { RecentlyViewed } from "../components/gallery/RecentlyViewed";
import { BookingNotice } from "../components/site/BookingNotice";
import { FestivalBanner } from "../components/site/FestivalBanner";
import { EnquirySection } from "../components/site/EnquirySection";
import { About } from "../components/site/About";
import { Faqs } from "../components/site/Faqs";
import { scrollToId } from "../lib/api";

export default function Home() {
  const loc = useLocation();
  useEffect(() => {
    const id = loc.hash.slice(1);
    if (!id) return undefined;
    const t = setTimeout(() => scrollToId(id, -100), 350);
    return () => clearTimeout(t);
  }, [loc]);

  return (
    <main data-testid="home-page">
      <Hero />
      <FestivalBanner />
      <Marquee />
      <Collections />
      <RecentlyViewed />
      <BookingNotice />
      <EnquirySection preset={loc.state} />
      <Faqs />
      <About />
    </main>
  );
}
